import { DefaultOptionType } from 'antd/es/select';

export const getDataAsMenuOptions = (
  data: Record<string, unknown>[],
  labelKey: string,
  valueKey: string,
) => {
  return data.map((item: Record<string, unknown>) => ({
    label: item?.[labelKey],
    value: item?.[valueKey],
  })) as DefaultOptionType[];
};

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};
